import { rankingItems } from '@/mocks/movies';

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-accent-500 text-sm"></i>;
  if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>;
  if (trend === 'new') return <span className="text-xs font-bold text-primary-500">NEW</span>;
  return null;
}

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热播排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            实时热门影片排行，高分电影在线热度一目了然
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={item.rank}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 hover:bg-background-200/50 transition-colors duration-200 cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span>{item.type}</span>
                  <span className="text-accent-600 font-semibold">{item.score}</span>
                </div>
              </div>

              <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
                <TrendIcon trend={item.trend} />
                <span className="text-xs text-foreground-600 whitespace-nowrap">{item.hot}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}